import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/client";
import type { BookingRequest, BookingResponse } from "@/api/types";
import { isErrorEnvelope } from "@/lib/handle-form-error";

export function useCreateBooking() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: BookingRequest) =>
      api.post("bookings", { json: data }).json<BookingResponse>(),
    onError: (error, variables) => {
      if (
        error instanceof HTTPError &&
        isErrorEnvelope(error.data) &&
        error.data.errors.some((entry) => entry.code === "slot_unavailable")
      ) {
        void queryClient.invalidateQueries({
          queryKey: ["businesses", variables.business_slug, "availability"],
        });
      }
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["bookings"] });
      void queryClient.invalidateQueries({
        queryKey: ["businesses", variables.business_slug, "availability"],
      });
      void queryClient.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
}
